// file: `react/src/utils/networkUtils.js`:

import axios from 'axios';

axios.defaults.withCredentials = true;

export const expressURL = () => {
  // Empty string = same origin (Express serves the React build).
  const expressURL = process.env.REACT_APP_API_URL || '';
  return expressURL;
};

// Cookie session. Do not send Authorization: Bearer.
export const getAuthHeaders = () => {
  return { credentials: 'include', withCredentials: true, headers: {} };
};

export function authFetch(url, init = {}) {
  const auth = getAuthHeaders();
  return fetch(url, {
    ...init,
    credentials: 'include',
    headers: {
      ...auth.headers,
      ...(init.headers || {})
    }
  });
}

function sameOriginWs(pathname) {
  if (typeof window === 'undefined') return '';
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${pathname}`;
}

// Production REACT_APP_WS_URL may be the https site URL. Browsers need wss://…/ws.
function toWebSocketUrl(raw, pathname) {
  const candidate = raw || (typeof window !== 'undefined' ? window.location.origin : '');
  if (!candidate) return sameOriginWs(pathname);
  try {
    const url = new URL(candidate);
    if (url.protocol === 'http:') url.protocol = 'ws:';
    else if (url.protocol === 'https:') url.protocol = 'wss:';
    else if (url.protocol !== 'ws:' && url.protocol !== 'wss:') return sameOriginWs(pathname);
    url.pathname = pathname;
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch (_) {
    return sameOriginWs(pathname);
  }
}

export const webSocketURL = () => toWebSocketUrl(process.env.REACT_APP_WS_URL, '/ws');
